import React from 'react';
import { portal, Portal } from '../../../../../../Configs/general';

import IndividualLoadGDC from './IndividualLoad.GDC';

const IndividualLoad = props => {
  switch (portal) {
    case Portal.Gascaribe:
    case Portal.Gasguajira:
    case Portal.Efigas:
      return <IndividualLoadGDC {...props} />;
    default:
      return <></>;
  }
};

export default IndividualLoad;
